import { validateSchema } from 'straightline-utils/hooks';

export default {
  before: {
    all: [],
    find: [],
    create: [validateSchema]
  },
  after: {
    all: [],
    find: [],
    create: []
  },
  error: {
    all: [],
    find: [],
    create: []
  }
};
